import React, {Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Feature from '../modules/Feature'
import Introduction from '../modules/Introduction'
import Section from '../modules/Section'
import Gallery from '../modules/Gallery'
import Carousel from '../modules/Carousel'
import Posts from '../modules/Posts'

class Home extends Component {
  render () {
    return (
      <div>
        <Feature {...this.props.feature}/>
        <div id="About">
          <Introduction introduction={this.props.introduction}/>
        </div>
        <div id="Works">
          <Section title='Works'>
            <Gallery gallery={this.props.works}/>
          </Section>
        </div>
        <div id="WhatVisitorsSay">
          <Carousel carousel={this.props.carousel}/>
        </div>
        <div id="YourVisit">
          <Section title=''>
            <Posts posts={this.props.news}/>
          </Section>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    feature: state.rist.content.feature,
    introduction: state.rist.content.introduction,
    works: state.rist.content.works,
    carousel: state.rist.content.carousel,
    news: state.rist.content.news,
  })
)(Home))



// WEBPACK FOOTER //
// ./src/Rist/containers/Home.js